 /*============ Appreciation Masthead Controller
  ================================*/
  angular.module("vppApp").controller("appreciationMastheadController", appreciationMastheadController);

  appreciationMastheadController.$inject = ["$scope", "appreciationMastheadFactory", '$element'];
 
  function appreciationMastheadController($scope, appreciationMastheadFactory, $element) {
 
    appreciationMastheadFactory().then(function(response) {
      var data = response.data.content;
      $scope.items = data;
    });
  }